type ProgressUnderlineProps = {
      value: number; // 0..100
      width?: number | string; // default 44 (px) - underline length
      thickness?: number; // default 4 (px)
      showPercentSign?: boolean; // default true
      muted?: boolean; // dims bar + text
      className?: string;
      titlePrefix?: string;
};

function getBarColor(v: number): { bg: string; track: string; glow: string } {
      if (v < 30) return { bg: "bg-destructive", track: "bg-destructive/15", glow: "shadow-[0_0_6px_oklch(0.55_0.18_25/0.5)]" };
      if (v < 60)
            return { bg: "bg-warning", track: "bg-warning/15", glow: "shadow-[0_0_6px_oklch(0.60_0.16_75/0.5)]" };
      return { bg: "bg-success", track: "bg-success/15", glow: "shadow-[0_0_6px_oklch(0.55_0.16_170/0.5)]" };
}

export function ProgressUnderline({
      value,
      width = 44,
      thickness = 4,
      showPercentSign = true,
      muted = false,
      className = "",
      titlePrefix = "Value",
}: ProgressUnderlineProps) {
      const v = Math.max(0, Math.min(100, Number.isFinite(value) ? value : 0));
      const { bg, track, glow } = getBarColor(v);

      return (
            <div
                  className={`inline-flex flex-col items-center ${muted ? "opacity-40" : ""} ${className}`}
                  title={`${titlePrefix}: ${v}%`}
                  aria-label={`${titlePrefix}: ${v}%`}
                  role="img"
                  style={{ width: typeof width === "number" ? `${width}px` : width }}
            >
                  <span className="text-xs tabular-nums leading-none text-center text-muted-foreground">
                        {v}
                        {showPercentSign ? "%" : ""}
                  </span>
                  <div
                        className={`mt-1 w-full rounded-full ${track} overflow-hidden`}
                        style={{ height: `${thickness}px` }}
                  >
                        <div className={`h-full rounded-full ${bg} ${muted ? "" : glow}`} style={{ width: `${v}%` }} />
                  </div>
            </div>
      );
}
